import { render, staticRenderFns } from "./BAutocompleteEventPublications.vue?vue&type=template&id=f43b325c&"
import script from "./BAutocompleteEventPublications.vue?vue&type=script&lang=js&"
export * from "./BAutocompleteEventPublications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports